import { render } from "./HomeCourseSubpage.vue?vue&type=template&id=6bf379dc&scoped=true"
import script from "./HomeCourseSubpage.vue?vue&type=script&lang=js"
export * from "./HomeCourseSubpage.vue?vue&type=script&lang=js"

import "./HomeCourseSubpage.vue?vue&type=style&index=0&id=6bf379dc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf379dc"]])

export default __exports__